import { imageUrl } from '../../utils/constants'
import { Modal } from '../modal/Modal'
import { SkeletonLoader } from '../skeletonLoader/SkeletonLoader'
import { ImageModalContent } from './components/imageModalContent/ImageModalContent'
import { useImageGallery } from './hooks/useImageGallery'
import classes from './ImageGallery.module.sass'

type Props = {
  urls?: string[] | []
  small?: boolean
}

export const ImageGallery = ({ urls, small }: Props) => {
  const { modalActive, setModalActive, openImageModal, image } = useImageGallery()

  if (urls)
    return (
      <div className={small ? classes.ContainerSmall : classes.Container}>
        {urls.length > 0 && small ? (
          <img
            alt="Изображение"
            key={urls[0]}
            className={small ? classes.ImageSmall : classes.Image}
            src={`${imageUrl + urls[0]}`}
          />
        ) : urls.length > 0 ? (
          urls.map((el) => (
            <img
              alt="Изображение"
              key={el}
              className={small ? classes.ImageSmall : classes.Image}
              src={`${imageUrl + el}`}
              onClick={() => {
                !small && openImageModal(el)
              }}
            />
          ))
        ) : (
          <SkeletonLoader
            count={1}
            style={{}}
            className={small ? 'ContainerCardSmall' : 'ContainerCard'}
          />
        )}
        <Modal image modalActive={modalActive} setModalActive={setModalActive}>
          <ImageModalContent image={image} />
        </Modal>
      </div>
    )
  return null
}
